package com.shadowings.gero.data.lessons.chapter8

import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.data.lessons.chapter6.getRecapImperfettivoQuiz
import com.shadowings.gero.data.repository.Hiero
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.*

fun getIntroVso8Content(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_intro_vso_8,
            content = Res.string.exp_content_intro_vso_8_alyn_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_intro_vso_8,
            content = Res.string.exp_content_intro_vso_8_nilo_1,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_intro_vso_8,
            content = Res.string.exp_content_intro_vso_8_alyn_2,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_intro_vso_8,
            content = Res.string.exp_content_intro_vso_8_alyn_3,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_intro_vso_8,
            content = Res.string.exp_content_intro_vso_8_alyn_4,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_intro_vso_8,
            content = Res.string.exp_content_intro_vso_8_alyn_5,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_intro_vso_8,
            content = Res.string.exp_content_intro_vso_8_nilo_2,
            face = Faces.Happy,
            character = Characters.Nilo,
        )
    )
}

fun getIntroVso8QuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    verbs: List<Verb>,
    languageCode: String
): List<IQuizContent> {
    return getRecapImperfettivoQuiz(words, verbs, languageCode)
}

